module.exports = __webpack_public_path__ + "site/img/waen.77fda84a.png";